
import Vue from 'vue'
import common from '../libs/common.mixin'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Msg from 'vux/src/components/msg/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'


export default {
mixins: [common],
components: {
XInput,
Group,
XButton,
Cell,
Msg,
Flexbox,
FlexboxItem
},
data () {
return {
TEXT_VCODE:'发送验证码',
TEXT_REST: '找回密码',
VCODE_LIMIT_SECONDS:0,
action:'intro',
vcode_sending:false,
isVcodeValid: false,
error: '',
resetpwd:{
account:'',
vcode:'',
password:'',
repassword:'',
reset_token: ''
}
}
},
computed:{
vcode_text(){
if(this.VCODE_LIMIT_SECONDS > 0){
return this.VCODE_LIMIT_SECONDS + '秒'
}
return this.TEXT_VCODE
},
rest_text(){
let result = this.TEXT_REST
if(this.isVcodeValid){
result = '确认重置'
}
return result
},
isMobileValid(){
let mreg = /^1[\d]{10}$/
return mreg.test(this.resetpwd.account)
},
isFormValid () {
let valid = true
let ereg = /^\s*$/
let mreg = /^1[\d]{10}$/
let value = this.resetpwd

if(!this.isVcodeValid){
if(mreg.test(value.account) && !ereg.test(value.vcode)){
valid = false
}
}else{
if(value.password.length>5&&value.password.length<21 && value.repassword.length>5&&value.repassword.length<21){
valid = false
}
}
return valid
}
},
methods:{
send_vcode(){
let params = {type:'student_forget'}
params.mobile = this.resetpwd.account
this.vcode_sending = true
this.$http.post('open/vcode',params)
.then(response=>{
this.error = ''
this.VCODE_LIMIT_SECONDS = 120
this.loop_check_vcode()
},response=>{
this.error = response.body.message
this.vcode_sending = false
})
},
loop_check_vcode(){
this.VCODE_LIMIT_SECONDS--
if(this.VCODE_LIMIT_SECONDS <= 0){
this.VCODE_LIMIT_SECONDS = 0
this.vcode_sending = false
return
}
setTimeout(()=>{
this.loop_check_vcode()
},1000)
},
resetPwd () {
if(!this.isVcodeValid){
let param = {mobile: this.resetpwd.account,vcode:this.resetpwd.vcode}
this.$http.post('open/check_vcode',param)
.then(response=>{
this.isVcodeValid = true
this.error = ''
this.resetpwd.reset_token = response.body.data.reset_token
},response=>{
this.error = response.body.message
})
}else{
let [param,resetpwd] = [{},this.resetpwd]
if(resetpwd.password != resetpwd.repassword){
this.error = '两次密码不一致'
return false
}
param.password = resetpwd.password
param.repassword = resetpwd.repassword
param.mobile = resetpwd.account
param.reset_token = resetpwd.reset_token
param.vcode = resetpwd.vcode

this.$http.post('open/reset_pwd',param)
.then(response=>{
this.error = ''
this.toast('找回成功','success')
setTimeout(()=>{
this.$router.push({path:'./login'})
},800)
}).catch(response=>{
this.error = response.body.message
})

}
}
}
}



// WEBPACK FOOTER //
// ./src/views/forgotpwd.vue